<script>
	// From Lucide
	import { TriangleAlert } from 'lucide-svelte';

	export let iconClass = '';
</script>

<TriangleAlert class={iconClass} />
